import { render, staticRenderFns } from "./ModalMakeItProductBonus.vue?vue&type=template&id=756172c2&scoped=true&"
import script from "./ModalMakeItProductBonus.vue?vue&type=script&lang=js&"
export * from "./ModalMakeItProductBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756172c2",
  null
  
)

export default component.exports